import {getRouteApi} from "@tanstack/react-router";

export const clientsRouteApi = getRouteApi("/_app/sales/clients/");
